import { createFileRoute } from "@tanstack/react-router";
import { HarvestPlanningView } from "@/features/harvest-journal/harvest-planning-view";
import { JournalPage } from "@/features/harvest-journal/components/journal-page";
import { useSessionStages } from "@/features/harvest-journal/hooks/use-session-stages";

export const Route = createFileRoute("/harvests/$session_id/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { session_id } = Route.useParams();
  const { isLoading } = useSessionStages(session_id);

  if (isLoading) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        Loading...
      </div>
    );
  }

  return (
    <JournalPage>
      <HarvestPlanningView session_id={session_id} />
    </JournalPage>
  );
}
